import {AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {MarketStore} from '@app/marketplace/stores/_models/store.interface';
import {Store} from '@ngrx/store';
import {UrlService} from '@app/services/url.service';
import {Meta, Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import * as storesSelectors from '@app/marketplace/stores/state/store/stores-selectors';
import * as storesActions from '@app/marketplace/stores/state/store/stores-actions';
import {ConfigurationPagedComponent, PaginatorComponent} from '@app/marketplace/shared/_components/paginator.component';
import {ConfigurationPagedSelectorModel, PaginationSelectorModel} from '@app/marketplace/shared/_models/pagination-selector.model';
import {fromEvent, Subscription} from 'rxjs';

@Component({
  selector: 'app-store-list',
  templateUrl: './store-list.component.html',
  styleUrls: ['./store-list.component.css']
})
export class StoreListComponent extends ConfigurationPagedComponent<MarketStore> implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('selectItems', { static: false })

  selectItems: ElementRef;
  payload: any;
  theme = {'min-width': '273px','min-height' : '198px',background: '#f1f1f1'};
  constructor(private store: Store<any>,
              private urlService: UrlService,
              private metaService: Meta,
              private titleService: Title,
              private route: ActivatedRoute,
              private router: Router,
              @Inject(PLATFORM_ID) private platformId) {
    super(route, metaService, titleService, router, store, platformId, new ConfigurationPagedSelectorModel(storesSelectors.selectLoading, storesSelectors.selectItems, storesSelectors.selectPageSize
      , storesSelectors.selectPageNo, storesSelectors.selectTotalPage, storesSelectors.selectTotalData, storesSelectors.selectCount, storesSelectors.selectConfiguration));
  }

  ngOnInit(): void {
    this.title = 'Cubatel Market | Tiendas asociadas a Cubatel con miles de productos';
    this.description = 'Descubre todas las tiendas que venden con Cubatel | Encuentra el mayor supermercado online para Cuba con entregas a domicilio en todas las provincias.';
    this.keywords = 'tiendas relacionadas con Cubatel, tiendas que venden con Cubatel';
    this.h1 = 'Tiendas asociadas a Cubatel';
    this.loadPrerender();
    this.payload= {
      "pageIndex": 1,
      "pageSize": 8,
      "pagingStrategy": 0,
      "locationType": 0,
      "locations": null,
      "locationResolver": false,
      "filter": {
        "searchTerms": "",
        "sortingArgs": 0,
        "categories": null,
        "priceRange": {
          "low": 1,
          "high": 250
        }
      },
      "categoryCode": "",
      "supplierCode": ""
    };
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      this.store.dispatch(storesActions.LoadingStoresActions({ payload: this.payload}));
    }
    this.urlService.changeUrl(this.router.url);
    this.urlService.footer.emit();
  }

  cancelRequest = () => this.store.dispatch(storesActions.CancelRequestStoresActions());

  ngOnDestroy(): void {
    //this._subscriptions.forEach(sb => sb.unsubscribe());
    this.cancelRequest();
  }

  pageChange($event: number) {
    this.payload.pageIndex = $event;
    this.store.dispatch(storesActions.LoadingStoresActions({ payload: this.payload}));
  }
  onImageLoad(item){
    console.info(item);
    //item.loaded=true
  }
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
   /*   fromEvent(this.selectItems.nativeElement, 'change')
      .subscribe(() => {
        this.payload.pageSize = this.selectItems.nativeElement.value;
        this.store.dispatch(storesActions.LoadingStoresActions({ payload: this.payload}));
      });  */
    }
  }

}
